import { FC } from 'react';
import moment from 'moment';
import { DatePicker } from 'iglooform';

interface IProps {
  onChange?: (value: any) => void;
  value?: any;
  disabledDate?: (date: moment.Moment) => boolean;
}

const DatePickerMonth: FC<IProps> = ({
  onChange,
  value,
  disabledDate = () => false,
}) => {
  return (
    <DatePicker
      format={'YYYY-MM'}
      picker="month"
      placeholder={' '}
      onChange={(value) => {
        const _value = value?.startOf('month')?.valueOf();
        onChange?.(_value);
      }}
      value={value}
      disabledDate={disabledDate}
    />
  );
};

export default DatePickerMonth;
